import getCookie from './getCookie';
import { CookieName } from './constants';
/**
 * Returns the specified cookie value or undefined (see ./getCookie)
 * @param {Object | string }     context server context
 * @returns {string | undefined} cookie value
 */
var getVCookie = function getVCookie(context) {
  return getCookie(CookieName.EXPERIMENT_IDENTIFIER, context);
};
export default getVCookie;